export const MEMORIZE_COLUMN_WIDTHS = 'grid/MEMORIZE_SET_COLUMN_WIDTHS';
